module.exports = __webpack_public_path__ + "static/media/Laugo_05.68383077.jpg";